import {
  AnyObject,
  CurdDataSetConfig,
  DeviceEvent,
  FormFieldType,
  Geofence,
  Geometric,
  GeometryMultiPolygon
} from '../types';
import { polygonsFromGeoJson, toDateFormat, toDateTimeFormat, toTimeFormat } from '@mri/functions';
import { tap } from 'rxjs';
import { ChoiceTypes } from '@mri/enums';
import { MobileAlarmEventShowComponent } from '../app/modules/mobile-alarm-event-show';


export const geofenceDeviceEventDataSetConfig: CurdDataSetConfig<DeviceEvent> = {
  entityName: 'Reporte de geocercas',
  collectionName: 'Reporte de geocercas',
  gatewayUrl: 'events',
  baseBreadcrumb: 'alarm-events',
  list: {
    pageConfig: {
      title: 'Reporte de geocercas',
      breadcrumb: [
        {
          title: 'Reportes',
          type: 'item'
        },
        {
          title: 'Geocercas',
          type: 'item',
          link: '/reports/geofences/list',
          pageName: 'Reporte de geocercas'
        }
      ]
    },
    saverFilterExclude: ['startCreatedTime', 'endCreatedTime'],
    extraQueryFilter: {
      type: ['entrance-geofence', 'exit-geofence']
    },
    table: {
      columns: [
        {
          key: 'deviceTime', label: 'Momento',
          getValue: ({ element }) => toDateTimeFormat(element.deviceTime)

        },
        {
          key: 'mobileId', label: 'Vehiculo',
          getValue: ({ element }) => element.mobile?.name || 'No definido'

        },
        {
          key: 'geofenceId', label: 'Geocerca',
          getValue: ({ element, component }) => {
            const configSrv = component?.configSrv;
            if (!configSrv) return 'Alarma no definida';

            const choices = configSrv.getChoices(ChoiceTypes.ALARM);
            const choice = choices.find(c => c.value === element.type);

            if (!choice) return 'Alarma no definida';

            const label = choice.label['es'] || choice.label['default'];
            if (!element.geofenceId) return label;

            return element.geofence?.name || 'No definido';
          }
        },
        {
          key: 'type', label: 'Tipo',
          getValue: ({ element, component }) => {
            const configSrv = component?.configSrv;
            if (!configSrv) return 'Tipo no definida';

            const choices = configSrv.getChoices(ChoiceTypes.ALARM);
            const choice = choices.find(c => c.value === element.type);

            if (!choice) return 'Tipo no definida';

            return choice.label['es'] || choice.label['default'];
          }
        },
        {
          key: 'address', label: 'Direccion',
          getValue({ element }) {
            const address = element.position?.address || 'No definido';

            return `<span class="text-expansible">${address}</span>`;
          }
        }
      ],
      noInitLoad: true,
      modeFilter: 'top',
      //onMapReady: prop => loadTravelMap(prop),
      //onLoadElements: prop => loadTravelMap(prop),
      onSelectedElements: ({ selectedElements, component }) => {

        if (!component?.map) return;

        const geofenceMap = new Set();
        const configSrv = component?.configSrv;
        const choices = configSrv?.getChoices(ChoiceTypes.ALARM);


        const markers = (selectedElements || [])
          .map((element) => {
            const choice = choices?.find(c => c.value === element.type);

            if (!element.position) return undefined;
            if (element.geofenceId) geofenceMap.add(element.geofenceId);
            /*
           const priceTag = document.createElement('div');
            priceTag.className = `<i class="${choice?.icon || 'fi fi-br-bell-ring'}"></i>`;
            priceTag.textContent = '$2.5M';

            return  new google.maps.Mar({
                position: {
                    lat: element.position.geometric.coordinates[1] as number,
                    lng:element.position.geometric.coordinates[0] as number
                },
                content: priceTag,
            });
            */

            const currentPosition = {
              lat: element.position.geometric.coordinates[1] as number,
              lng: element.position.geometric.coordinates[0] as number
            };

            const mapElements: Array<AnyObject> = [];

            const markerContent = document.createElement('div');
            markerContent.className = 'circle-marker';
            markerContent.innerText = 'B';
            mapElements.push(new google.maps.Marker({
              position: currentPosition,

            }));

            if(element.prevPosition){
              const prevPosition = {
                lat: element.prevPosition.geometric.coordinates[1] as number,
                lng: element.prevPosition.geometric.coordinates[0] as number
              }

              const markerContent = document.createElement('div');
              markerContent.className = 'circle-marker';
              markerContent.innerText = 'A';
              mapElements.push(new google.maps.Marker({
                position: prevPosition,
              }));
            }

            return mapElements;

          }).filter(element => element).flat();

        component?.addMapElements('selected', markers);
        if (selectedElements?.length)
          component?.centerMap(selectedElements?.filter(e => e.position).map(e => e.position?.geometric) as Geometric[] || []);

        if (!geofenceMap.size) return;
        return component.genericResourceSrv.getElements<Geofence>('geofences', {
          filter: { id: [...geofenceMap] },
          paginate: { page: 1, size: 999 }
        })
          .pipe(
            tap(response => {
              const polygons = response.objects.map(geofence => polygonsFromGeoJson(geofence.geometric as GeometryMultiPolygon)).flat();

              component?.addMapElements('selectedPolygons', polygons);
            })
          );


        /*if (!component?.map) return;
        const markers = (selectedElements || [])
          .map((element) => {
            return new google.maps.Marker({
              position: {
                lat: element.geometric.coordinates[1] as number,
                lng: element.geometric.coordinates[0] as number
              },
              icon: {
                path: 'm197.058594 257.113281-186.9375-69.761719 430.617187-177.351562-171.359375 433.242188zm0 0',
                fillColor: 'rgb(27, 139, 249)',
                fillOpacity: 1,
                scale: 0.06,
                strokeColor: 'rgba(33, 33, 33, 0.6)',
                strokeWeight: 2,
                anchor: new google.maps.Point(265, 200),
                rotation: element.course || 0
              }
            });
          });

        component?.addMapElements('selected', markers);

        if (selectedElements?.length)
          component?.centerMap(selectedElements?.map(e => e.geometric) || []);*/
      }
    },
    card: {
      structure: {
        title: ({ element, component }) => {
          const configSrv = component?.configSrv;
          if (!configSrv) return 'Evento no definida';

          const choices = configSrv.getChoices(ChoiceTypes.ALARM);
          const choice = choices.find(c => c.value === element.type);

          if (!choice) return 'Evento no definida';

          const label = [element.mobile?.name || '', choice.label['es'] || choice.label['default']]
            .join(' - ');
          return `<strong>${label}</strong>`;
        },
        icon: ({ element, component }) => {
          const configSrv = component?.configSrv;
          const choices = configSrv?.getChoices(ChoiceTypes.ALARM);
          const choice = choices?.find(c => c.value === element.type);

          return {
            class: choice?.icon || 'fi fi-br-bell-ring',
            background: choice?.color
          };
        },
        body: ({ element }) => {
          const geofenceLabel = element.geofenceId ? `<span class="text-muted badge"> ${element.geofence?.name || 'No definido'}</span>` : '';

          return [
            {
              type: 'html',
              value: `
                <div>
                   ${geofenceLabel}
                  <div>${element.position?.address?.split(',').slice(0, 2).join(', ') || 'Direccion no definida'}</div>
                 
                  <div>
                    <span class="badge"> <i class="fi fi-br-calendar"></i> ${toDateFormat(element.deviceTime)}</span>
                    <span class="badge"> <i class="fi fi-br-clock"></i> ${toTimeFormat(element.deviceTime)}</span>
                  </div>
                </div>
                `
            }
          ];
        }
      }
    },
    actionsKeys: ['delete'],
    extraActions: [
      {
        key: 'info',
        label: 'Informacion',
        icon: 'fi fi-rr-eye',
        click: ({ selectedElements, component }) => {
          const element = selectedElements?.[0];
          if (element === undefined) return;

          component?.openDrawer(
            'Informacion de evento de alarma',
            MobileAlarmEventShowComponent,
            { elementId: element._id }
          );
        },
        inRow: true,
        disableWhen: ({ selectedElements }) => selectedElements?.length !== 1
      }
    ],
    filter: [
      {
        key: 'mobileId',
        label: 'Vehiculo',
        type: FormFieldType.OPTIONS,
        optionsGateway: 'mobiles',
        containerClass: 'col-12 col-md-4'
      },
      {
        key: 'startDeviceTime',
        label: 'Hora y fecha inicial',
        type: FormFieldType.DATE_TIME,
        containerClass: 'col-12 col-md-4',
        fillDefaultValue: () => new Date(toDateFormat(new Date()) + 'T00:00:00').toJSON()
      },
      {
        key: 'endDeviceTime',
        label: 'Hora y fecha final',
        type: FormFieldType.DATE_TIME,
        containerClass: 'col-12 col-md-4',
        fillDefaultValue: () => new Date(toDateFormat(new Date()) + 'T23:59:59').toJSON()
      }
    ]
  },
  pages: ['list']
};
